module.exports = __webpack_public_path__ + "img/icon13.1c181818.png";